export default {
  getRoleById: state => id => {
    return state.roles.find(role => Number(role.id) === Number(id));
  },

  getRoleIndexById: state => id => {
    return state.roles.findIndex(role => Number(role.id) === Number(id));
  }
};
